import axios from "../interceptors/axios";

export default class GenderService {
  list = async (params={}) => {
    try {
      const response = await axios.get("/api/gender/list", { params });
      return response;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

  create = async (data) => {
    try {
      const response = await axios.post("/api/gender/create", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  edit = async (data) => {
    try {
      const response = await axios.put("/api/gender/edit", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  delete = async (params) => {
    try {
      const response = await axios.delete("/api/gender/delete", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

}
